import React, { useMemo } from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const EditPersonalia = ({ member, match, user }) => {
  const { operator: { id, locales } } = React.useContext(AppContext)
  const token = useMemo(() => window.localStorage.getItem('auth-token'), [])

  if (!id) {
    return (
      <div className='index memberships' />
    )
  }

  return (
    <div className='box-wrapper'>
      <cl-member-personalia
        apiHost={`https://memberships.${env()}.credlock.net`}
        mountPath={`/operators/${id}/members`}
        operatorid={id}
        token={token}
        id={member.id}
        locales={locales}
      />
    </div>
  )
}

export default EditPersonalia
